import { borderRadius, ButtonGroup } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const StyledButtonGroup = styled(ButtonGroup)<{
  $variant?: 'primary' | 'secondary';
}>`
  width: fit-content;
  white-space: nowrap;
  border-radius: 10px;

  [data-button-group-item] {
    ${borderRadius.r2}
  }

  ${({ $variant }) =>
    $variant === 'secondary' &&
    css`
      background-color: var(--surface-active);
      border: 0;
      padding: 2px;

      [data-button-group-item] {
        padding: 8px;

        &:hover {
          background-color: var(--surface-hover);
        }
      }
    `}
`;

export const Wrapper = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    fill: ${({ $active }) =>
      $active ? 'var(--icon-primary)' : 'var(--icon-soft)'};

    path {
      fill: ${({ $active }) =>
        $active ? 'var(--icon-primary)' : 'var(--icon-soft)'};
    }
  }
`;
